import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ThreatMap from "./components/ThreatMap";
import About from "./components/About";
import Services from "./components/Services";
import CertificacionesAlianzas from "./components/CertificacionesAlianzas";
import DatacenterSection from "./components/DatacenterSection";
import CTABanner from "./components/CTABanner";
import Industries from "./components/Industries";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Toast from "@/components/base/Toast";
import InfoModal from "@/components/feature/InfoModal";
import QuoteModal from "@/components/feature/QuoteModal";
import RegionSelector from "@/components/feature/RegionSelector";
import CookieConsent from "@/components/feature/CookieConsent";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";
import ScrollReveal from "@/components/feature/ScrollReveal";
import Capacitaciones from "./components/Capacitaciones";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);
  const [regionDone, setRegionDone] = useState(false);
  const [regionForceOpen, setRegionForceOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const state = location.state as
      | { scrollTo?: string; openModal?: string; openQuote?: boolean; openRegion?: boolean }
      | null;
    if (!state) return;
    if (state.openModal) {
      setModalType(state.openModal);
      setModalOpen(true);
    }
    if (state.openRegion) {
      setRegionForceOpen(true);
    }
    if (state.openQuote) {
      setQuoteOpen(true);
    }
    if (state.scrollTo) {
      setTimeout(() => {
        const el = document.querySelector(state.scrollTo as string);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, [location.state]);

  const openModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setModalType(null), 300);
  };

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  const handleOpenRegionSelector = () => {
    setRegionForceOpen(true);
  };

  const handleRegionComplete = () => {
    setRegionDone(true);
    setRegionForceOpen(false);
  };

  return (
    <div className="relative">
      <RegionSelector onComplete={handleRegionComplete} forceOpen={regionForceOpen} />
      {regionDone && <CookieConsent />}
      <Navbar onOpenModal={openModal} onOpenRegionSelector={handleOpenRegionSelector} onOpenQuote={openQuote} />
      <LanguageTransitionWrapper>
        <main>
          <Hero onOpenQuote={openQuote} />
          <ThreatMap />
          <ScrollReveal delay={0}>
            <CertificacionesAlianzas />
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <About onOpenModal={openModal} />
          </ScrollReveal>
          <ScrollReveal delay={0}>
            <Services onOpenModal={openModal} />
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <Capacitaciones onOpenModal={openModal} />
          </ScrollReveal>
          <ScrollReveal delay={0}>
            <DatacenterSection onOpenModal={openModal} />
          </ScrollReveal>
          <ScrollReveal delay={50}>
            <CTABanner />
          </ScrollReveal>
          <ScrollReveal delay={0}>
            <Industries />
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <Contact />
          </ScrollReveal>
        </main>
        <ScrollReveal delay={50}>
          <Footer onOpenModal={openModal} />
        </ScrollReveal>
      </LanguageTransitionWrapper>
      <Toast />
      <WhatsAppFloat />
      <InfoModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalType={modalType}
        onOpenQuote={(service) => {
          closeModal();
          openQuote(service);
        }}
      />
      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
    </div>
  );
}